import { Button } from 'antd';

const { Group: ButtonGroup } = Button;

export default ButtonGroup;
